export default "__VITE_ASSET__B66t1Cir__"